import { useChatStore } from '@/stores/chat-store';
import { ChatHeader } from './chat-header';
import { MessageList } from './message-list';
import { ChatInput } from './chat-input';

export function ChatPanel() {
  const { selectedConversation } = useChatStore();

  if (!selectedConversation) {
    return null;
  }

  return (
    <div className="flex-1 flex flex-col min-h-0">
      <ChatHeader />
      <MessageList />
      <ChatInput />
    </div>
  );
}
